export default __webpack_public_path__ + "a071abba7e9bd90947f74e34f411dfbc.woff2";